import React from 'react'

function AirField({ runway, lightsOn = false, ...props }) {
  const { name, headwind, crosswind, wind } = runway

  return (
    <svg viewBox="0 0 975 956" {...props}>
      <g
        id="Page-1"
        stroke="none"
        strokeWidth="1"
        fill="none"
        fillRule="evenodd"
      >
        <g
          id="field"
          transform="translate(487.754498, 477.696743) rotate(-48.000000) translate(-487.754498, -477.696743) translate(212.754498, 69.696743)"
        >
          <path
            d="M407.67695,86.1494802 L407.814421,86.3024802 L410.245502,86.303257 L410.245421,89.0024802 L459.823421,144.06448 L464.150918,140.303257 L494.985692,175.774607 L491.533421,178.77448 L507.382421,206.22648 L511.162758,204.216856 L535.575279,250.130131 L519.682223,258.580619 L495.269702,212.667344 L502.965421,208.57448 L487.689421,182.11648 L482.910339,186.271552 L452.075565,150.800201 L452.275421,150.62548 L436.876421,133.52248 L425.838376,143.461611 L411.786633,127.85557 L422.824421,117.91648 L404.263421,97.3024802 L378.245421,97.3024802 L378.245502,815.303257 L327.245502,815.303257 L327.245502,787.303257 L356.245502,787.303257 L356.245421,97.3024802 L333.245502,97.303257 L333.245502,86.303257 L407.506421,86.3024802 L407.67695,86.1494802 Z M30.9047396,215.666751 L37.6335715,217.596212 L35.4764212,225.11748 L71.2664212,235.37948 L72.9047396,229.666751 L94.0524969,235.730773 L87.7128377,257.839792 L66.5650804,251.77577 L69.3364212,242.10748 L33.5464212,231.84648 L24.9542531,261.81425 L18.2254212,259.884789 L30.9047396,215.666751 Z"
            id="Runway"
            fill="#D8D8D8"
          ></path>
          <g
            id="banbelysning"
            transform="translate(337.961361, 167.572094)"
            fill={lightsOn ? '#FFCB6A' : '#D8D8D8'}
          >
            <circle id="lampa" cx="7.98436031" cy="7.32872282" r="7"></circle>
            <circle id="lampa" cx="49.6834927" cy="8.80600456" r="7"></circle>
            <circle id="lampa" cx="8.22441877" cy="83.8136388" r="7"></circle>
            <circle id="lampa" cx="49.9235511" cy="85.2909205" r="7"></circle>
            <circle id="lampa" cx="8.09440614" cy="167.359932" r="7"></circle>
            <circle id="lampa" cx="49.7935385" cy="168.837214" r="7"></circle>
            <circle id="lampa" cx="8.63352411" cy="251.64937" r="7"></circle>
            <circle id="lampa" cx="50.3326565" cy="253.126652" r="7"></circle>
            <circle id="lampa" cx="8.05942616" cy="343.669316" r="7"></circle>
            <circle id="lampa" cx="49.7585585" cy="345.146597" r="7"></circle>
            <circle id="lampa" cx="7.78438773" cy="443.493783" r="7"></circle>
            <circle id="lampa" cx="49.4835201" cy="444.971065" r="7"></circle>
            <circle id="lampa" cx="8.25249412" cy="542.64912" r="7"></circle>
            <circle id="lampa" cx="49.9516265" cy="544.126402" r="7"></circle>
          </g>
          <g
            id="vindibana"
            transform="translate(381.745502, 418.803257)"
            fill="#000000"
            fontFamily="Helvetica"
            fontSize="23"
            fontWeight="normal"
          >
            <text
              id="vindibana_text"
              transform="translate(10.000000, 46.500000) rotate(90.000000) translate(-10.000000, -46.500000) "
            >
              <tspan x="-36" y="52">
                {`${Math.abs(Math.round(crosswind))} kt ${
                  name === '12' ? '↓' : '↑'
                } ${Math.abs(Math.round(headwind))} kt ${
                  name === '12' ? '←' : '→'
                }`}
              </tspan>
            </text>
          </g>
          <g
            id="30airplane"
            transform="translate(366.745502, 99.803257) rotate(-135.000000) translate(-366.745502, -99.803257) translate(357.245502, 90.303257)"
            fillRule="nonzero"
            fillOpacity={name === '12' ? 1 : 0}
            fill="green"
            width={66}
            height={43}
            rx={4}
          >
            <path
              d="M3.7932777,3.7812376 C3.7259064,3.8486085 3.7323964,3.9347702 3.9650313,4.4373336 C3.9924894,4.4966515 4.1453716,4.7138571 4.1453716,4.7138571 C4.1453723,4.7138561 4.0426847,4.8268489 4.0148394,4.8546943 C3.9610053,4.9085284 3.9361984,5.0293335 3.958161,5.1243469 C4.026297,5.4191302 4.8480608,6.5947712 5.3081405,7.0548517 C5.593652,7.3403629 5.7408456,7.5354068 5.730653,7.6147666 C5.7220521,7.6817367 5.6138788,7.9698607 5.4901987,8.2536889 C5.2719706,8.7544933 5.1902268,8.8530093 2.7284084,11.592571 C0.7788774,13.76205 0.1823532,14.462131 0.1469587,14.620578 C0.0488216,15.059908 0.4289737,15.468046 1.4110617,15.977428 L1.9177343,16.24021 C1.9177343,16.24021 9.306553,10.950215 9.306553,10.950215 L13.736066,14.314858 L13.634732,14.495198 C13.578751,14.594046 13.11587,15.171307 12.60593,15.778194 C12.095992,16.385083 11.673006,16.939029 11.666441,17.009665 C11.640049,17.293626 12.777085,18.186772 12.947719,18.016137 C13.217037,17.74682 14.346696,16.884968 14.441971,16.875697 C14.509995,16.869079 15.481025,16.128624 15.810843,15.798805 C16.140662,15.468987 16.881117,14.497956 16.887735,14.429933 C16.897006,14.334658 17.758859,13.204999 18.028176,12.93568 C18.198811,12.765045 17.305664,11.62801 17.021702,11.654403 C16.951067,11.660967 16.397123,12.083953 15.790233,12.593891 C15.183346,13.103831 14.606085,13.566712 14.507236,13.622693 L14.326897,13.724027 L10.962253,9.294514 C10.962253,9.294514 16.252249,1.9056938 16.25225,1.9056938 L15.989466,1.3990218 C15.480084,0.416933 15.071947,0.0367811 14.632617,0.1349189 C14.474169,0.1703136 13.774089,0.7668355 11.60461,2.7163677 C8.8650471,5.1781859 8.7665321,5.2599294 8.2657298,5.4781579 C7.9819013,5.601838 7.6937782,5.7100098 7.6268071,5.7186131 C7.5474478,5.7288044 7.352405,5.5816098 7.0668925,5.2960996 C6.6068129,4.8360191 5.4311712,4.0142561 5.1363875,3.9461203 C5.0413739,3.9241577 4.92057,3.9489642 4.8667352,4.0027982 C4.8388891,4.0306446 4.7276147,4.1316136 4.7276147,4.1316136 C4.7276147,4.1316136 4.5104099,3.9787304 4.4510923,3.9512732 C3.9485278,3.7186391 3.8606505,3.7138647 3.7932777,3.7812376 Z"
              id="path13"
            ></path>
          </g>
          <g
            id="12airplane"
            transform="translate(366.745502, 799.803257) rotate(46.000000) translate(-366.745502, -799.803257) translate(357.245502, 790.303257)"
            fillRule="nonzero"
            fillOpacity={name === '30' ? 1 : 0}
            fill="green"
            width={66}
            height={43}
            rx={4}
          >
            <path
              d="M3.7932777,3.7812376 C3.7259064,3.8486085 3.7323964,3.9347702 3.9650313,4.4373336 C3.9924894,4.4966515 4.1453716,4.7138571 4.1453716,4.7138571 C4.1453723,4.7138561 4.0426847,4.8268489 4.0148394,4.8546943 C3.9610053,4.9085284 3.9361984,5.0293335 3.958161,5.1243469 C4.026297,5.4191302 4.8480608,6.5947712 5.3081405,7.0548517 C5.593652,7.3403629 5.7408456,7.5354068 5.730653,7.6147666 C5.7220521,7.6817367 5.6138788,7.9698607 5.4901987,8.2536889 C5.2719706,8.7544933 5.1902268,8.8530093 2.7284084,11.592571 C0.7788774,13.76205 0.1823532,14.462131 0.1469587,14.620578 C0.0488216,15.059908 0.4289737,15.468046 1.4110617,15.977428 L1.9177343,16.24021 C1.9177343,16.24021 9.306553,10.950215 9.306553,10.950215 L13.736066,14.314858 L13.634732,14.495198 C13.578751,14.594046 13.11587,15.171307 12.60593,15.778194 C12.095992,16.385083 11.673006,16.939029 11.666441,17.009665 C11.640049,17.293626 12.777085,18.186772 12.947719,18.016137 C13.217037,17.74682 14.346696,16.884968 14.441971,16.875697 C14.509995,16.869079 15.481025,16.128624 15.810843,15.798805 C16.140662,15.468987 16.881117,14.497956 16.887735,14.429933 C16.897006,14.334658 17.758859,13.204999 18.028176,12.93568 C18.198811,12.765045 17.305664,11.62801 17.021702,11.654403 C16.951067,11.660967 16.397123,12.083953 15.790233,12.593891 C15.183346,13.103831 14.606085,13.566712 14.507236,13.622693 L14.326897,13.724027 L10.962253,9.294514 C10.962253,9.294514 16.252249,1.9056938 16.25225,1.9056938 L15.989466,1.3990218 C15.480084,0.416933 15.071947,0.0367811 14.632617,0.1349189 C14.474169,0.1703136 13.774089,0.7668355 11.60461,2.7163677 C8.8650471,5.1781859 8.7665321,5.2599294 8.2657298,5.4781579 C7.9819013,5.601838 7.6937782,5.7100098 7.6268071,5.7186131 C7.5474478,5.7288044 7.352405,5.5816098 7.0668925,5.2960996 C6.6068129,4.8360191 5.4311712,4.0142561 5.1363875,3.9461203 C5.0413739,3.9241577 4.92057,3.9489642 4.8667352,4.0027982 C4.8388891,4.0306446 4.7276147,4.1316136 4.7276147,4.1316136 C4.7276147,4.1316136 4.5104099,3.9787304 4.4510923,3.9512732 C3.9485278,3.7186391 3.8606505,3.7138647 3.7932777,3.7812376 Z"
              id="path13"
            ></path>
          </g>
          <g id="30sign" transform="translate(386.245502, 765.303257)">
            <rect
              fillOpacity={1}
              fill={name === '30' ? 'green' : 'red'}
              width={66}
              height={43}
              rx={4}
            ></rect>
            <path
              d="M23.2727175,33.3181815 C27.7840768,33.3181815 31.1363463,30.4886388 31.1363463,26.6818242 C31.1363463,23.7272816 29.386348,21.5795563 26.4545326,21.0909204 L26.4545326,20.9091024 C28.8068031,20.193194 30.2727108,18.2613777 30.2727108,15.6363802 C30.2727108,12.3409288 27.6704406,9.40911341 23.3636341,9.40911341 C19.340903,9.40911341 15.9999971,11.8863838 15.8636341,15.5454712 L18.5909038,15.5454712 C18.6931764,13.2272916 20.8977197,11.8636565 23.318172,11.8636565 C25.8863513,11.8636565 27.5454407,13.4204732 27.5454407,15.7727437 C27.5454407,18.2272868 25.624988,19.8181944 22.8636341,19.8181944 L20.9999924,19.8181944 L20.9999924,22.318192 L22.8636341,22.318192 C26.3977145,22.318192 28.3636217,24.1136448 28.3636217,26.6818242 C28.3636217,29.1477309 26.2158965,30.8181839 23.227263,30.8181839 C20.5340837,30.8181839 18.3977221,29.4318216 18.2272677,27.1818237 L15.3636341,27.1818237 C15.5340885,30.8409111 18.7613581,33.3181815 23.2727175,33.3181815 Z M43.3636268,33.3181815 C48.4999856,33.3181815 51.4545282,28.9659129 51.4545282,21.3636475 C51.4545282,13.8182001 48.4545311,9.40911341 43.3636268,9.40911341 C38.2727255,9.40911341 35.2727255,13.8182001 35.2727255,21.3636475 C35.2727255,28.9659129 38.2272681,33.3181815 43.3636268,33.3181815 Z M43.3636268,30.8181839 C39.9772664,30.8181839 37.9999956,27.4204599 37.9999956,21.3636565 C37.9999956,15.3181987 39.9999956,11.8636565 43.3636268,11.8636565 C46.72726,11.8636565 48.7272581,15.3181987 48.7272581,21.3636565 C48.7272581,27.4204599 46.7499872,30.8181839 43.3636268,30.8181839 Z"
              id="30"
              fill="#FFFFFF"
              fillRule="nonzero"
            ></path>
          </g>
          <g id="12sign" transform="translate(284.245502, 108.303257)">
            <rect
              fillOpacity={1}
              fill={name === '12' ? 'green' : 'red'}
              width={66}
              height={43}
              rx={4}
            ></rect>
            <path
              d="M26.590899,33 L26.590899,9.72729492 L23.7727199,9.72729492 L17.9545436,13.5909276 L17.9545436,16.4545612 L23.6363564,12.6818376 L23.7727199,12.6818376 L23.7727199,33 L26.590899,33 Z M47.9545292,33 L47.9545292,30.5000024 L37.1363577,30.5000024 L37.1363577,30.3181844 L42.3636254,24.7272806 C46.3636216,20.4431938 47.5454386,18.4431957 47.5454386,15.8636527 C47.5454386,12.272747 44.6363505,9.40911341 40.5454453,9.40911341 C36.4659037,9.40911341 33.363634,12.181838 33.363634,16.2727432 L36.0454496,16.2727432 C36.0454496,13.6250185 37.7613571,11.8636565 40.4545363,11.8636565 C42.9772612,11.8636565 44.9090775,13.4091134 44.9090775,15.8636527 C44.9090775,18.0113779 43.6477151,19.6022855 40.9545358,22.5454645 L33.272725,30.9545474 L33.272725,33 L47.9545292,33 Z"
              id="12"
              fill="#FFFFFF"
              fillRule="nonzero"
              transform="translate(32.954536, 21.204557) rotate(180.000000) translate(-32.954536, -21.204557) "
            ></path>
          </g>
          <g
            id="vindt"
            transform={`translate(220.465578, 353.693005) rotate(${
              wind.direction - 30 - 90
            }) translate(-220.465578, -353.693005) translate(165.965578, 261.693005)`}
          >
            <path
              d="M-9.10535652e-13,183.817919 L-9.09494702e-13,166.817919 L40,166.817919 L40,0.817919315 L68,0.817919315 L68,166.817919 L109,166.817919 L109,183.817919 L-9.10535652e-13,183.817919 Z"
              id="Combined-Shape"
              fill="#FF7E46"
            ></path>
            <text
              id="072º-5-kt"
              transform={`translate(55.000000, 92.317919) rotate(${
                90 + (name === '30' ? 180 : 0)
              }) translate(-55.000000, -92.317919)`}
              fontFamily="Helvetica"
              fontSize="23"
              fontWeight="normal"
              fill="#000000"
            >
              <tspan x="9.5" y="101.317919">
                {`${`${wind.direction + 1000}`.substring(1)}º ${Math.round(
                  wind.speed
                )} kt`}
              </tspan>
            </text>
          </g>
          <g
            id="Byggnader"
            transform="translate(0.350384, 0.411620)"
            fill="#000000"
          >
            <rect
              id="Rectangle"
              transform="translate(485.295131, 152.985386) rotate(-41.000000) translate(-485.295131, -152.985386) "
              x="477.295131"
              y="128.985386"
              width="16"
              height="48"
            ></rect>
            <rect
              id="Rectangle"
              transform="translate(457.242114, 127.561574) rotate(-41.000000) translate(-457.242114, -127.561574) "
              x="453.742114"
              y="124.061574"
              width="7"
              height="7"
            ></rect>
            <rect
              id="Rectangle"
              x="226.295131"
              y="50.9853863"
              width="33"
              height="23"
            ></rect>
            <rect
              id="Rectangle"
              transform="translate(148.027786, 62.816240) rotate(-26.000000) translate(-148.027786, -62.816240) "
              x="134.027786"
              y="38.8162398"
              width="28"
              height="48"
            ></rect>
            <rect
              id="Rectangle"
              transform="translate(123.558703, 89.964086) rotate(-26.000000) translate(-123.558703, -89.964086) "
              x="111.558703"
              y="83.4640862"
              width="24"
              height="13"
            ></rect>
            <rect
              id="Rectangle"
              transform="translate(95.806421, 108.055229) rotate(-29.000000) translate(-95.806421, -108.055229) "
              x="77.8064208"
              y="103.555229"
              width="36"
              height="9"
            ></rect>
            <rect
              id="Rectangle"
              transform="translate(52.552761, 127.852329) rotate(-31.000000) translate(-52.552761, -127.852329) "
              x="30.5527613"
              y="118.852329"
              width="44"
              height="18"
            ></rect>
            <rect
              id="Rectangle"
              transform="translate(75.408084, 172.421816) rotate(-31.000000) translate(-75.408084, -172.421816) "
              x="50.9080844"
              y="163.921816"
              width="49"
              height="17"
            ></rect>
            <rect
              id="Rectangle"
              transform="translate(131.408084, 140.421816) rotate(-31.000000) translate(-131.408084, -140.421816) "
              x="106.908084"
              y="131.921816"
              width="49"
              height="17"
            ></rect>
            <rect
              id="Rectangle"
              transform="translate(155.163945, 152.425415) rotate(-38.000000) translate(-155.163945, -152.425415) "
              x="143.663945"
              y="143.925415"
              width="23"
              height="17"
            ></rect>
            <rect
              id="Rectangle"
              transform="translate(139.435951, 11.500000) rotate(-43.000000) translate(-139.435951, -11.500000) "
              x="127.935951"
              y="7"
              width="23"
              height="9"
            ></rect>
            <rect
              id="Rectangle"
              transform="translate(91.264335, 53.795004) rotate(-43.000000) translate(-91.264335, -53.795004) "
              x="77.2643354"
              y="49.2950041"
              width="28"
              height="9"
            ></rect>
            <rect
              id="Rectangle"
              transform="translate(16.123048, 188.915688) rotate(-74.000000) translate(-16.123048, -188.915688) "
              x="6.12304766"
              y="183.415688"
              width="20"
              height="11"
            ></rect>
            <rect
              id="Rectangle"
              transform="translate(17.448725, 221.156056) rotate(-74.000000) translate(-17.448725, -221.156056) "
              x="7.44872529"
              y="211.156056"
              width="20"
              height="20"
            ></rect>
            <rect
              id="Rectangle"
              transform="translate(12.000000, 242.233533) rotate(-74.000000) translate(-12.000000, -242.233533) "
              x="4"
              y="232.233533"
              width="16"
              height="20"
            ></rect>
            <rect
              id="Rectangle"
              transform="translate(481.581839, 193.590945) rotate(-36.000000) translate(-481.581839, -193.590945) "
              x="476.581839"
              y="187.090945"
              width="10"
              height="13"
            ></rect>
            <rect
              id="Rectangle"
              transform="translate(530.590924, 223.660965) rotate(-28.000000) translate(-530.590924, -223.660965) "
              x="522.590924"
              y="201.160965"
              width="16"
              height="45"
            ></rect>
          </g>
        </g>
      </g>
    </svg>
  )
}

export default AirField
